/* @sravni/react-design-system version 0.2.65 */
import formatDate from 'date-fns/format';
import { ru } from 'date-fns/locale';
import isValidDate from 'date-fns/isValid';
import getMonth from 'date-fns/getMonth';
import getYear from 'date-fns/getYear';
import { MONTHS } from '../../DateInput/constants/index.js';

var getISODate = function (date) { return formatDate(date, 'yyyy-MM-dd'); };
var getDateFormatted = function (date, dateFormat, locale) {
    if (dateFormat === void 0) { dateFormat = 'dd.MM.yyyy'; }
    if (locale === void 0) { locale = ru; }
    return formatDate(date, dateFormat, { locale: locale });
};
var getDayFormatted = function (date) { return formatDate(date, 'd'); };
var getMonthFormatted = function (date) { return MONTHS[getMonth(date)] + " " + getYear(date); };
var isValid = function (date) {
    try {
        return isValidDate(date);
    }
    catch (e) {
        return false;
    }
};

export { getDateFormatted, getDayFormatted, getISODate, getMonthFormatted, isValid };
//# sourceMappingURL=date.js.map
